import {
  axiosConfig
} from './articleList'
import {
  URLROUTER
} from './config'


//获取始发站列表
export function getAllStart(config) {
  let Obj = {
    'url': URLROUTER + '/ZzPub/ClientService/Bus/getAllStart',
    'method': "post"
  }
  return axiosConfig(Object.assign({}, Obj, config))
}
//获取到达站列表
export function getAllStop(config) {
  let Obj = {
    'url': URLROUTER + '/ZzPub/ClientService/Bus/getAllStop',
    'method': "post"
  }
  return axiosConfig(Object.assign({}, Obj, config))
}
//根据始发站到达站获取运行班次信息列表
export function getBusInfoStop(config) {
  let Obj = {
    'url': URLROUTER + '/ZzPub/ClientService/Bus/getBusInfoStop',
    'method': "post"
  }
  return axiosConfig(Object.assign({}, Obj, config))
}



// WEBPACK FOOTER //
// ./src/api/index.js